import gsap from 'gsap/gsap-core';
import React, {useRef, useEffect, useState} from 'react';
import { StyledHomeHeroDark } from './StyledHomeHeroDark';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import {
  setLoader,
} from "../../redux/loader/loader.actions";

gsap.registerPlugin(ScrollTrigger);

const HomeHeroDark = ({ isLoaded, hasClosingCopy, isShelfzone}) => {

  const slidesInterval = useRef(null);
  const videosRef = useRef(new Array())
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState(0);
  const dispatch = useDispatch();
  let history = useHistory();

  const videoRef = useRef(null);
  const [isPaused, setIsPaused] = useState(true)
  const [isMuted, setIsMuted] = useState(false)

  const toggleMute = () => {
    setIsMuted(!isMuted)
  }
  const togglePlay  = () =>  {
    setIsPaused(!isPaused)
    transitionPlay(!isPaused)
  }

  const toogleShowOverlay = (show) => {
    var TL = gsap.timeline();

    if(show){

      videosRef.current[current].pause();

      TL
      .set('.hero--video-wrap', {left: 0})
      .to('.hero--video-wrap',{opacity: 1})
      setIsPaused(!isPaused)
      transitionPlay(!isPaused)
      setTimeout(() => videoRef.current.play(), 0)
    }else{
      setIsPaused(!isPaused)
      transitionPlay(!isPaused)
      videoRef.current.pause();
      videosRef.current[current].play();
      TL
      .to('.hero--video-wrap',{opacity: 0})
      .set('.hero--video-wrap', {left: '-100%'})
    }
  }
  const tooglePlayOverlay = (play) => {
    
    if(!play){
      setIsPaused(isPaused)
      transitionPlay(!isPaused)
      videoRef.current.pause()
    }else{
      
      setIsPaused(isPaused)
      transitionPlay(isPaused)
      setTimeout(() => videoRef.current.play(), 1250)
    }
  }
  const transitionPlay = (toggle) => {
    var TL = gsap.timeline();

    if(toggle)
      TL
      .to('.pause-bar', {y: 56, stagger: 0.1, duration: 0.5,  ease: "Power2.easeOut" })
      .to('.circle--bg', {scale: 1.1, opacity: 1, duration: 0.25,  ease: "Power2.easeInOut"}, '-=0.25')
      .to('.play-icon', {opacity: 1, rotate: 0, duration: 0.25,  ease: "Power2.easeOut" })
      .to('.circle--bg', {scale: 0.75, opacity: 0, duration: 0.5,  ease: "Power2.easeInOut" }, '-=0.25')
    else
      TL
      .to('.circle--bg', {scale: 0.75, opacity: 0, duration: 0.5, ease: "Power2.easeInOut" })
      .to('.play-icon', {opacity: 0, duration: 0.75, scale: 0.5, ease: "Power2.easeOut", onComplete: () => {
        gsap.set('.play-icon', {rotate: -45, scale: 1})
      } }, '-=0.25')
      .to('.pause-bar', {y: 0, stagger: 0.1, duration: 0.5,  ease: "Power2.easeOut" })
  }

  const triggerHover = (isHover) => {
    var TL = gsap.timeline();
    
    if(!('ontouchstart' in window)){

      if(isHover)
        TL
        .to('.play-icon', {scale: 1.1,  duration: 0.75,  ease: "Power2.easeInOut" })
        .to('.circle--bg', {scale: 1.1, opacity: 1, duration: 0.5,  ease: "Power2.easeOut" }, '-=0.25')
        
      else
        TL
        .to('.circle--bg', {scale: 0.75, opacity: 0, duration: 0.75, ease: "Power2.easeInOut" })
        .to('.play-icon', {scale: 1, duration: 0.75, ease: "Power2.easeOut"}, '-=0.25')
    }
    
  }

  const slidesHome = [
    {
      "title": "Building the Metaverse since 2015",
      "cta": "Discover more",
      "ctaLink": "/news/working-in-the-metaverse",
      "videoDesk": require('../../assets/video/homepage_metaverse.mp4'),
      "videoMobile": require('../../assets/video/homepage_metaverse-mobile.mp4')
    },
    {
      "title": "3D e-commerce: experience the Full View",
      "cta": "Discover more",
      "ctaLink": "/3d-e-commerce",
      "videoDesk": require('../../assets/video/homepage_commerce.mp4'),
      "videoMobile": require('../../assets/video/homepage_commerce-mobile.mp4')
    },
    {
      "title": "Rethink your definition of reality",
      "cta": "Push to start",
      "hasVideoCta": true,
      "videoDesk": require('../../assets/video/home-video-trailer.mp4'),
      "videoMobile": require('../../assets/video/home-video-trailer-MOBILE.mp4')
    }
  ]

  const slidesShelzone = [
    {
      "title": "Building beyond boundaries and expectations",
      
      "videoDesk": require('../../assets/video/video-01-shelfzone.mp4'),
      "videoMobile": require('../../assets/video/video-01-shelfzone.mp4')
    },
    {
      "title": "Test the limits of your industry",
 
      "videoDesk": require('../../assets/video/video-02-shelfzone.mp4'),
      "videoMobile": require('../../assets/video/video-02-shelfzone.mp4')
    },
    {
      "title": "Showcase your business in a whole new way",

      "videoDesk": require('../../assets/video/video-03-shelfzone.mp4'),
      "videoMobile": require('../../assets/video/video-03-shelfzone.mp4')
    }
  ]

  const slides = isShelfzone ? [...slidesShelzone] : [...slidesHome];
  const handleEndVideo = () => {
    
    setCurrent(current + 1 > (slides.length - 1) ? 0 : current + 1)
    setPrev(current)
    
  }
  

  useEffect(() => {
    let vh = window.innerHeight * 0.01;
    
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    // require('../../assets/video/home-new.mp4') : require('../../assets/video/home-new-mobile.mp4')}
  }, [])


  const handleSelection = (index) => {
    clearInterval(slidesInterval.current);
    setPrev(current);
    setCurrent(index);

  }

  useEffect(() => {
    videosRef.current[prev].pause()
    videosRef.current[current].currentTime = 0;
    videosRef.current[current].play()

  }, [current])

  const handleCLick = (slug) => {
    if(history.location.pathname !== slug){
      dispatch(setLoader(true))
      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
  }

  return (
    <React.Fragment>
      {
       
          <StyledHomeHeroDark indexCurrent={current}>
            <div className="hero-dark--wrap">
              <div className='hero-dark--slider'>
                {
                  slides.map((k,i) => {
                    const selected = i === current ? 'selected' : "";
                    return <div key={i} className={`${selected} hero--video-loop`}>
                              <div className="loop-wrap">
                                <div className="opacity-layer"></div>
                                <video 
                                  ref={(element) => videosRef.current.push(element)}
                                  playsInline
                                  muted
                                  preload="metadata" 
                                  onEnded={() => handleEndVideo(i)}
                                >
                                  <source src={ window.innerWidth > 1023 ? k.videoDesk : k.videoMobile}  type="video/mp4"></source>
                                </video>
                              </div>
                            <div className="text-wrap-cta">
                              {
                                !isShelfzone &&
                                <h4 className="md--title">
                                  { k.title }
                                </h4>
                              }
                              {
                                isShelfzone &&
                                <div className="row-shelfzone">
                                  <img src={require('../../assets/logo-shelfzone.png')} />
                                  <h4 className="md--title">
                                    { k.title }
                                  </h4>
                                </div>
                              }
                              {
                                (!k.hasVideoCta && k.cta !== undefined) &&
                                <div className="rounded--cta" onClick={() => handleCLick(k.ctaLink)} >
                                  <p>{ k.cta }</p>
                                </div>
                              }
                              {
                                (k.hasVideoCta && k.cta !== undefined) &&
                                <div className="rounded--cta" onClick={() => toogleShowOverlay(true, i)} >
                                  <p>{ k.cta }</p>
                                </div>
                              }
                            </div>
                          </div>
                  })
                }
              </div>
              <div className='bullets--wrap'>
                {
                  slides.map((k,i) => {
                    const selected = i === current ? 'selected' : "";
                    return <div key={i} className={ `${selected} bullet`} onClick={() => handleSelection(i)}></div>
                  })
                }
              </div>
              <div className="hero--video-wrap">
                <div className="video-holder">
                  <video 
                    ref={videoRef} 
                    playsInline muted={isMuted} preload="metadata" 
                  >
                    <source src={ window.innerWidth > 1023 ? require('../../assets/video/home-new.mp4') : require('../../assets/video/home-new-mobile.mp4')}  type="video/mp4"></source>
                  </video>
                </div>
                <div className="close-video" onClick={() => toogleShowOverlay(false)}>
                  <img src={require('../../assets/close-overlay.png')} />
                </div>
                <div 
                  className={isPaused ? "play paused" : "play"} 
                  onClick={() => tooglePlayOverlay(true)}
                  onMouseEnter={() => triggerHover(true)}
                  onMouseLeave={() => triggerHover()}
                >
                  <img className="play-icon" src="/main-play.svg" />
                  <div className="circle--bg"></div>
                </div>
                
                <div className={isPaused ? "small-play paused" : "small-play"} onClick={() => tooglePlayOverlay(false)}>
                  <span className="pause-bar"></span>
                  <span className="pause-bar"></span>
                </div>
                <div className={isMuted ? "toggle-audio" : "toggle-audio mute"} onClick={() => toggleMute()}></div>
              </div>
            </div>
            
            {
              hasClosingCopy &&
              <div className="hero-dark-text--wrap">
                <h1 className="big--title">We’re your partner in enhancing the retail experience</h1>
                <p className="preset-11">With Invrsion, you’ll find a solution that exceeds your business needs and expectations. We help you create digital retail experiences that fully immerse your customers in your brand beyond any physical limitations. Allowing you to sell anything, anywhere, to anyone.</p>
              </div>
            }
          </StyledHomeHeroDark>
          
      }
    </React.Fragment>
  );
};

HomeHeroDark.propTypes = {};

HomeHeroDark.defaultProps = {
  tag: "div",
  bgColor: "#fff",
  black: "#003D2B"
};

export default HomeHeroDark;
